module.exports = __webpack_public_path__ + "static/media/event.e67a1ac3.mp4";